<template>
  <h-dialog
    v-model="visible"
    top="5vh"
    :width="width + 50 +'px'"
    :title="dialogTitle"
    :okText="$t('common.cropButton')"
    @onCancel="handleCancel"
    @onOk="cropperOk"
    :confirmLoading="confirmLoading"
  >
    <el-row type="flex" justify="center" :style="{width: width+'px', height: height+'px'}">
      <vue-cropper
        ref="cropper"
        v-bind="options"
      >
      </vue-cropper>
    </el-row>
    <el-row class="crop-footer">
      <span>{{ $t('common.cropHint') }}</span>
      <span v-if="progressTotal > 1" class="crop-progress">{{ progressCurrent }}/{{ progressTotal }}</span>
    </el-row>
  </h-dialog>
</template>

<script setup>
import { VueCropper } from 'vue-cropper'
import 'vue-cropper/dist/index.css'
import { computed, nextTick, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { $t } from '@/i18n'

const visible = ref(false),
  options = ref({}),
  confirmLoading = ref(false),
  url = ref(),
  cropper = ref()

const emit = defineEmits(['cropping-success', 'cropping-cancel'])

const width = ref(600)
const height = ref(600)
const progressCurrent = ref(0)
const progressTotal = ref(0)

const dialogTitle = computed(() => {
  if (progressTotal.value > 1) {
    return `${$t('common.cropTitle')} (${progressCurrent.value}/${progressTotal.value})`
  }
  return $t('common.cropTitle')
})

function toggleVisible(_options) {
  const { autoCropWidth = 600, autoCropHeight = 600, progress = {} } = _options
  width.value = autoCropWidth
  height.value = autoCropHeight
  progressCurrent.value = Number(progress.current) || 0
  progressTotal.value = Number(progress.total) || 0
  options.value = { ..._options }
  if (!visible.value) {
    nextTick(() => {
      visible.value = true
    })
  }
}

function close() {
  visible.value = false
}

function handleCancel() {
  visible.value = false
  confirmLoading.value = false
  emit('cropping-cancel')
}

function cropperOk() {
  confirmLoading.value = true
  cropper.value.getCropBlob(async (blob) => {
    if (blob) {
      emit('cropping-success', blob, () => {
        confirmLoading.value = false
      })
    } else {
      confirmLoading.value = false
      ElMessage.error($t('common.cropFailed'))
    }
  })
}

defineExpose({
  toggleVisible,
  close
})
</script>

<style lang="scss" scoped>
.crop-footer {
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.crop-progress {
  color: #606266;
}
</style>
